/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { EntitlementStatus } from "./EntitlementStatus";
import type { Feature } from "./Feature";
import type { GrantType } from "./GrantType";
import type { SourceType } from "./SourceType";

/**
 * One entitlement, projected from all events sharing a ``grant_id``.
 *
 * This is the unit of "a thing that grants access": a single subscription, one one-time
 * purchase, a partner sponsorship, etc. ``source_type``/``source_id``/``grant_type`` together
 * answer "what is this and where did it come from"; ``features`` is what it unlocks.
 */
export interface Entitlement {
  grant_id: string;
  grant_type: GrantType;
  source_type: SourceType;
  source_id: string | null;
  source_partner?: string | null;
  features: Feature[];
  remaining_usages: number | null;
  valid_from: string | null;
  valid_until: string | null;
  status: EntitlementStatus;
}
